<template>
  <div class="income-container finance-wrap">
    <el-form ref="form" :model="form" :inline="true" size="small">
      <el-row :gutter="10">
        <el-col :span="4">
          <el-select filterable clearable v-model="query.OrgId" placeholder="账户名称" style="width: 100%;">
            <el-option v-for="item in accountList" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <DateRangePicker :startDate.sync="query.startDate" :endDate.sync="query.endDate" style="width: 100%;">
          </DateRangePicker>
        </el-col>
        <el-col :span="4">
          <el-select filterable clearable v-model="query.MerchantId" placeholder="商户名称" style="width: 100%;">
            <el-option v-for="item in merchantList" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-select v-model="query.status" placeholder="审批状态" style="width: 100%;" clearable>
            <el-option label="待审批" :value="0"></el-option>
            <el-option label="审批通过" :value="1"></el-option>
            <el-option label="审批失败" :value="-1"></el-option>
          </el-select>
        </el-col>
        <el-col :span="3">
          <el-input v-model="query.keyword" style="width: 100%;" placeholder="关键字"></el-input>
        </el-col>
        <el-col :span="3">
          <div class="box-input-btn">
            <el-button class="box-input-btn-cz" @click="resetQuery">重置</el-button>
            <el-button class="default" @click="initGetQueryretransactionrecord">查询</el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <div>
      <div class="status-container">
        <div class="status-item status-all" :class="{ 'active': query.status==null }" @click="setActiveStatus(null)">
          全部{{ dataCount.pendingCount+dataCount.paidCount+dataCount.unPaidCount }}
        </div>
        <div class="status-item status-pending" :class="{ 'active': query.status === 0 }" @click="setActiveStatus(0)">
          待审批{{ dataCount.pendingCount }}
        </div>
        <div class="status-item status-paid" :class="{ 'active': query.status === 1 }" @click="setActiveStatus(1)">
          审批通过{{ dataCount.paidCount }}
        </div>
        <div class="status-item status-unpaid" :class="{ 'active': query.status === -1 }" @click="setActiveStatus(-1)">
          未收到{{ dataCount.unPaidCount }}
        </div>
      </div>
      <el-table :data="tableData"
        :header-cell-style="{ backgroundColor: '#F2F4F7', color: '#333', fontWeight: 'bold', textAlign: 'center', fontSize: '12px' }"
        style="width: 100%" :height="'570px'" :cell-style="{ 'text-align': 'center' }">
        <el-table-column fixed prop="accountName" label="账户名称">
        </el-table-column>
        <el-table-column prop="typeName" label="类型">
          <template slot-scope="scope">
            <span :class="['type-tag', scope.row.typeName === '收入' ? 'income' : 'expend']">
              {{ scope.row.typeName }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="merchatCompanyName" label="商户">
          <template slot-scope="scope">
            <span>{{ scope.row.merchatCompanyName||'-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="amount" label="金额">
        </el-table-column>
        <el-table-column prop="userName" label="操作人">
        </el-table-column>
        <el-table-column prop="createdTime" label="创建日期">
        </el-table-column>
        <el-table-column prop="statusName" label="审批状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 1" class="status-tag-solid approved">通过</span>
              <span v-else-if="scope.row.status == -1" class="status-tag-solid failed">失败</span>
              <span v-else-if="scope.row.status == -2" class="status-tag-solid failed">已撤销</span>
              <span v-else class="status-tag-solid pending">审核</span>
            <!-- <span v-if="scope.row.status == 1" class="status-tag approved">通过</span>
            <span v-else-if="scope.row.status == -1" class="status-tag failed">失败</span>
            <span v-else class="status-tag pending">待审</span> -->
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注">
          <template slot-scope="scope">
            <span>{{ scope.row.remark||'-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="imageUrl" label="截图" >
          <template slot-scope="scope">
            <el-image v-if="scope.row.imageUrl" :src="scope.row.imageUrl" :preview-src-list="[scope.row.imageUrl]"
              fit="cover" style="height: 60px; cursor: pointer;"></el-image>
            <div v-else>-</div>
          </template>
        </el-table-column>
        <el-table-column prop="audiRemark" label="审批备注" >
          <template slot-scope="scope">
            <span>{{ scope.row.audiRemark||'-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" v-if="scope.row.status != 1 && scope.row.status != -1 && scope.row.status != -2"
              @click="handleConfirmReceive(scope.row)">确认收款</el-button>
            <el-button type="text" size="small" @click="handleNotReceived(scope.row)"
              v-if="scope.row.status != 1 && scope.row.status != -1 && scope.row.status != -2">未收到</el-button>
            <el-button type="text" size="small" @click="openDetailDialog(scope.row)">查看订单</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 查看订单详情对话框 -->
      <el-dialog title="订单详情" :visible.sync="detailDialogVisible" width="600px">
        <div class="detail-container" v-if="selectedRow">
          <div class="detail-row">
            <div class="detail-item">
              <span class="detail-label">账户名称:</span>
              <span class="detail-value">{{ selectedRow.accountName }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">类型:</span>
              <span class="detail-value">{{ selectedRow.typeName }}</span>
            </div>
          </div>
          <div class="detail-row">
            <div class="detail-item">
              <span class="detail-label">商户:</span>
              <span class="detail-value">{{ selectedRow.merchatCompanyName }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">金额:</span>
              <span class="detail-value">{{ selectedRow.amount }}</span>
            </div>
          </div>
          <div class="detail-row">
            <div class="detail-item">
              <span class="detail-label">操作人:</span>
              <span class="detail-value">{{ selectedRow.userName }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">创建日期:</span>
              <span class="detail-value">{{ selectedRow.createdTime }}</span>
            </div>
          </div>
          <div class="detail-row">
            <div class="detail-item">
              <span class="detail-label">审批状态:</span>
              <span class="detail-value">
                <span v-if="selectedRow.status == 1" style="color: #67C23A;">通过</span>
                <span v-else-if="selectedRow.status == -1" style="color: #F56C6C;">失败</span>
                <span v-else style="color: #E6A23C;">待审</span>
              </span>
            </div>
            <div class="detail-item">
              <span class="detail-label">备注:</span>
              <span class="detail-value">{{ selectedRow.remark || '-' }}</span>
            </div>
          </div>
          <div class="screenshot-section" v-if="selectedRow.screenshot">
            <p class="section-title">截图:</p>
            <img :src="selectedRow.screenshot" class="screenshot-img" />
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <!-- <el-button @click="handleConfirmReceive(selectedRow)" type="primary">确认收款</el-button>
          <el-button @click="handleNotReceived(selectedRow)" type="danger">未收到</el-button> -->
          <el-button @click="detailDialogVisible = false">关闭</el-button>
        </span>
      </el-dialog>

      <!-- 备注对话框 -->
      <el-dialog :title="currentAction=='confirm' ? '确认收款':'未收到'" :visible.sync="remarkDialogVisible" width="600px">
        <el-form :model="remarkForm" label-width="80px">
          <el-form-item label="收款人">
            <div>{{ selectedRow.userName }}</div>
          </el-form-item>
          <el-form-item label="收款账户">
            <div>{{ selectedRow.accountName }}</div>
          </el-form-item>
          <el-form-item label="收款金额">
            <div>{{ selectedRow.amount }}</div>
          </el-form-item>
          <el-form-item label="收款日期">
            <div>{{ selectedRow.createdTime }}</div>
          </el-form-item>
          <el-form-item label="收款备注">
            <div>{{ selectedRow.remark || '-' }}</div>
          </el-form-item>
          <el-form-item label="快照">
            <div>{{ selectedRow.imageUrl || '-' }}</div>
          </el-form-item>
          <el-form-item label="审批备注">
            <el-input v-model="remarkForm.remark" type="textarea" :rows="3" placeholder="请输入备注信息"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="remarkDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="submitRemark">确定</el-button>
        </span>
      </el-dialog>

      <div class="table-pagination">
        <el-pagination @current-change="currentChange" :current-page="query.page" :page-size="query.pageSize"
          layout="total, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { queryretransactionrecord, getQueryaccount, audiretransactionrecord } from '@/api/finance'
import { merchant } from '@/api/settings'
import DateRangePicker from '@/components/DateRangePicker.vue';
export default {
  components: {
    DateRangePicker
  },
  data() {
    return {
      form: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: ''
      },
      activeStatus: 'pending',
      tableData: [],
      accountList: [],
      merchantList: [],
      detailDialogVisible: false,
      selectedRow: {},
      remarkDialogVisible: false,
      dataCount:{
        paidCount:0,
        pendingCount:0,
        unPaidCount:0,
      },
      remarkForm: {
        remark: ''
      },
      currentAction: '',
      query: {
        keyword: '',
        status: '',
        startDate: '',
        endDate: '',
        MerchantId: '',
        page: 1,
        pageSize: 10,
      },
      total: 0,
    }
  },
  methods: {
    setActiveStatus(status) {
      this.query.status = status;
      this.initGetQueryretransactionrecord();
    },
    currentChange(value) {
      this.query.page = value;
      this.getQueryretransactionrecord();
    },
    getQueryretransactionrecord() {
      queryretransactionrecord({
        "OrgId": this.query.OrgId,
        "Keyword": this.query.keyword,
        "Status": this.query.status,
        "StartDate": this.query.startDate,
        "EndDate": this.query.endDate,
        MerchantId: this.query.MerchantId,
        "Page.Index": this.query.page,
        "Page.Size": this.query.pageSize,
      }).then(res => {
        this.tableData = res.data.rows;
        this.total = res.data.total;
        this.dataCount={
          paidCount:res.data.paidCount,
          pendingCount:res.data.pendingCount,
          unPaidCount:res.data.unPaidCount,
        }
      })
    },
    initGetQueryretransactionrecord() {
      this.query.page = 1;
      this.getQueryretransactionrecord();
    },
    resetQuery() {
      this.query = {
        keyword: '',
        status: '',
        startDate: '',
        endDate: '',
        MerchantId: '',
        page: 1,
        pageSize: 10,
      };
      this.getQueryretransactionrecord();
    },
    openDetailDialog(row) {
      this.selectedRow = row;
      this.detailDialogVisible = true;
    },
    handleConfirmReceive(row) {
      this.detailDialogVisible = false;
      this.selectedRow = row;
      this.currentAction = 'confirm';
      this.remarkForm.remark = '';
      this.remarkDialogVisible = true;
    },
    handleNotReceived(row) {
      this.detailDialogVisible = false;
      this.selectedRow = row;
      this.currentAction = 'notReceived';
      this.remarkForm.remark = '';
      this.remarkDialogVisible = true;
    },
    submitRemark() {
      if (this.currentAction === 'confirm') {
        console.log('确认收款:', this.selectedRow, '备注:', this.remarkForm.remark);
        audiretransactionrecord({
          id: this.selectedRow.id,
          flag: true,
          audiRemark: this.remarkForm.remark
        }).then(res => {
          if (res.code == 1) {
            this.$message({
              type: 'success',
              message: '操作成功'
            });
          }
        });
      } else if (this.currentAction === 'notReceived') {
        console.log('未收到:', this.selectedRow, '备注:', this.remarkForm.remark);
        audiretransactionrecord({
          id: this.selectedRow.id,
          flag: false,
          audiRemark: this.remarkForm.remark
        }).then(res => {
          if (res.code == 1) {
            this.$message({
              type: 'success',
              message: '操作成功'
            });
          }
        });
      }
      this.remarkDialogVisible = false;
      this.getQueryretransactionrecord();
    },
  },
  created() {
    getQueryaccount({
      "Page.Index": 1,
      "Page.Size": 9999,
    }).then(res => {
      this.accountList = res.data.rows.map(t => {
        return {
          label: t.accountName,
          value: t.id,
        }
      });
    })
    merchant().then(res => {
      this.merchantList = res.data.rows.map(t => {
        return {
          label: t.companyName,
          value: t.id,
        }
      });
    })
    this.getQueryretransactionrecord();
  }
}
</script>
<style scoped lang="scss">
.income-container {}

.status-container {
  display: flex;
  margin-top: 20px;
  margin-bottom: 16px;

  .status-item {
    padding: 4px 12px;
    margin-right: 8px;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.3s;
    font-size: 12px;
    background-color: transparent;

    &.status-all {
      border: 1px solid #409EFF;
      color: #409EFF;
      &.active {
        background-color: #409EFF;
        color: white;
      }
    }

    &.status-pending {
      border: 1px solid #E6A23C;
      color: #E6A23C;
      &.active {
        background-color: #E6A23C;
        color: white;
      }
    }

    &.status-paid {
      border: 1px solid #67C23A;
      color: #67C23A;
      &.active {
        background-color: #67C23A;
        color: white;
      }
    }

    &.status-unpaid {
      border: 1px solid #F56C6C;
      color: #F56C6C;
      &.active {
        background-color: #F56C6C;
        color: white;
      }
    }
  }

}
 .type-tag {
    display: inline-block;
    padding: 1px 8px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 500;

    &.income {
      background-color: #E8F5E9;
      color: #67C23A;
      border: 1px solid #67C23A;
    }

    &.expend {
      background-color: #FEE2E2;
      color: #F56C6C;
      border: 1px solid #F56C6C;
    }
  }

  .status-tag {
    display: inline-block;
    padding: 2px 8px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 500;
    background-color: transparent;

    &.approved {
      border: 1px solid #67C23A;
      color: #67C23A;
    }

    &.failed {
      border: 1px solid #F56C6C;
      color: #F56C6C;
    }

    &.pending {
      border: 1px solid #E6A23C;
      color: #E6A23C;
    }
  }

.table-pagination {
  margin-top: 15px;
  text-align: right;
}

.detail-container {
  padding: 10px;

  .detail-row {
    display: flex;
    margin-bottom: 16px;
  }

  .detail-item {
    flex: 1;
    display: flex;
    align-items: center;
  }

  .detail-label {
    color: #909399;
    font-size: 14px;
    min-width: 80px;
  }

  .detail-value {
    color: #303133;
    font-size: 14px;
  }

  .screenshot-section {
    margin-top: 20px;

    .section-title {
      font-size: 14px;
      margin-bottom: 10px;
      color: #606266;
    }

    .screenshot-img {
      max-width: 100%;
      max-height: 300px;
      border-radius: 4px;
      border: 1px solid #e4e7ed;
    }
  }
}

.finance-wrap {
  // width: 953px;
  width: calc(100% - 30px);

  ::v-deep .el-select {
    margin-right: 5px;
    width: 125px;
  }

  ::v-deep .el-input__inner {
    background: #F2F4F7;
    border: none;
  }

  ::v-deep .el-table__row {
    .cell {
      font-size: 12px;
    }
  }

  ::v-deep .el-date-editor {
    margin-right: 5px;
    width: 240px;

    .el-range-input {
      background: transparent;
    }

    .el-range__close-icon {
      width: 10px;
    }
  }

  .box-table {
    height: calc(100% - 210px) !important;

    ::v-deep .el-table__body-wrapper {
      height: 100% !important;
      height: auto !important;
    }
  }

  .box-top {
    width: 593px;
    height: 81px;
    background: #FFFFFF;
    box-shadow: 0px 3px 12px 1px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding: 5px 10px;

    .top-item {
      width: 30%;

      p {
        color: #666;
        font-size: 12px;
      }

      .balance {
        color: #333333;
        font-size: 20px;
        font-weight: bold;
      }

      .iconfont {
        vertical-align: middle;
        margin-right: 5px;
      }
    }
  }

}

.box-input-btn {
  text-align: right;

  .box-input-btn-cz {
    background: #EAF3FF;
    color: #3888E9;
    border: none;
  }

  .box-input-btn-add {
    background: #D8F5E4;
    color: #54D8A5;
    border: none;
  }
}
.status-tag-solid {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;

  &.approved {
    background-color: #67C23A;
    color: white;
  }

  &.failed {
    background-color: #F56C6C;
    color: white;
  }

  &.pending {
    background-color: #E6A23C;
    color: white;
  }
}

</style>
